import React, { useEffect, useState, useRef } from 'react';
import {
    LoadingComponent,
    ErrorDataComponent,
} from '../loadingErrorNoDataComponents';

export const TxtViewer = ({ fileName, fileUrl, scrollToLine }) => {
    const [lines, setLines] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const lineRefs = useRef({});

    useEffect(() => {
        const fetchTextContent = async () => {
            try {
                const response = await fetch(fileUrl);
                if (!response.ok) {
                    throw new Error('Failed to fetch text content');
                }
                const text = await response.text();

                const linesArr = text
                    .split('\n')
                    .map((line) =>
                        line
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                    );

                setLines(linesArr);
                setIsLoading(false);
            } catch (err) {
                setError(err.message);
                setIsLoading(false);
            }
        };

        if (fileUrl) {
            fetchTextContent();
        }
    }, [fileUrl]);

    // Scroll effect: defer scroll after render
    useEffect(() => {
        if (!isLoading && scrollToLine) {
            requestAnimationFrame(() => {
                const ref = lineRefs.current[scrollToLine];
                if (ref) {
                    ref.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        }
    }, [isLoading, scrollToLine]);

    if (isLoading) {
        return <LoadingComponent fileName={fileName} />;
    }

    if (error) {
        return <ErrorDataComponent fileName={fileName} />;
    }

    return (
        <div className='text-content relative h-full'>
            <div className='absolute inset-0 overflow-auto p-4 whitespace-pre-wrap font-mono text-sm text-texts-secondary'>
                {lines.map((line, index) => (
                    <div
                        key={index}
                        ref={(el) => (lineRefs.current[index + 1] = el)}
                        dangerouslySetInnerHTML={{ __html: line }}
                    />
                ))}
            </div>
        </div>
    );
};
